export enum InterfaceEventName {
  AccountDropdownButtonClicked = 'Account Dropdown Button Clicked',
  ApproveTokenTxnSubmitted = 'Approve Token Transaction Submitted',
  ChainChanged = 'Chain Changed',
  CollectLiquidityFailed = 'Collect Liquidity Failed',
  ConnectWalletButtonClicked = 'Connect Wallet Button Clicked',
  CreatePositionFailed = 'Create Position Failed',
  DecreaseLiquidityFailed = 'Decrease Liquidity Failed',
  EmbeddedWalletCreated = 'Embedded Wallet Created',
  ExploreBannerClicked = 'Explore Banner Clicked',
  ExploreSearchSelected = 'Explore Search Selected',
  ExploreTokenRowClicked = 'Explore Token Row Clicked',
  ExtensionUninstallFeedback = 'Extension Uninstall Feedback',
  ExternalLinkClicked = 'External Link Click',
  FiatOnrampBannerClicked = 'Fiat Onramp Banner Clicked',
  FiatOnrampWidgetOpened = 'Fiat Onramp Widget Opened',
  IncreaseLiquidityFailed = 'Increase Liquidity Failed',
  LanguageSelected = 'Language Selected',
  LimitedWalletSupportToastDismissed = 'Limited Wallet Support Toast Dismissed',
  LimitedWalletSupportToastLearnMoreButtonClicked = 'Limited Wallet Support Learn More Button Clicked',
  LimitedWalletSupportToastShown = 'Limited Wallet Support Toast Shown',
  LimitExpirySelected = 'Limit Expiry Selected',
  LimitPresetRateSelected = 'Limit Preset Rate Selected',
  LimitPriceReversed = 'Limit Price Reversed',
  LocalCurrencySelected = 'Local Currency Selected',
  MigrateLiquidityFailed = 'Migrate Liquidity Failed',
  MiniPortfolioToggled = 'Mini Portfolio Drawer Toggled',
  NavbarResultSelected = 'Navbar Result Selected',
  NavbarSearchExited = 'Navbar Search Exited',
  NavbarSearchSelected = 'Navbar Search Selected',
  NoQuoteReceivedFromQuickrouteAPI = 'No quote received from quickroute API',
  NoQuoteReceivedFromRoutingAPI = 'No quote received from routing API',
  OnChainAddLiquidityFailed = 'On Chain Add Liquidity Failed',
  PortfolioMenuOpened = 'Portfolio Menu Opened',
  RiskChecked = 'Risk Checked',
  SendInitiated = 'Send Initiated',
  SendRecipientSelected = 'Send Recipient Selected',
  SwapTabClicked = 'Swap Tab Clicked',
  TokenImported = 'Token Imported',
  TokenSelected = 'Token Selected',
  TokenSelectorOpened = 'Token Selector Opened',
  UniswapWalletAppDownloadOpened = 'Uniswap Wallet App Download Opened',
  UniswapWalletConnectModalOpened = 'Uniswap wallet modal opened',
  UniswapWalletMicrositeOpened = 'Uniswap Wallet Microsite Opened',
  UniswapXOrderCancelInitiated = 'UniswapX Order Cancel Initiated',
  UniswapXOrderDetailsSheetOpened = 'UniswapX Order Details Sheet Opened',
  UniswapXOrderPostError = 'UniswapX Order Post Error',
  UniswapXOrderSubmitted = 'UniswapX Order Submitted',
  UniswapXSignatureDeadlineExpired = 'UniswapX Signature Deadline Expired',
  UniswapXSignatureRequested = 'UniswapX Signature Requested',
  WalletCapabilitiesDetected = 'Wallet Capabilities Detected',
  WalletConnected = 'Wallet Connected',
  WalletProviderUsed = 'Wallet Provider Used',
  WalletSelected = 'Wallet Selected',
  WrapTokenTxnInvalidated = 'Wrap Token Transaction Invalidated',
  WrapTokenTxnSubmitted = 'Wrap Token Transaction Submitted',
  // alphabetize additional values.
}
